import React, { useEffect, useState, useCallback } from "react";
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  TablePagination,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import { api_base, Api_Token } from "../../../env";
import { useAlertContext } from "../../../service/AlertServices";
import Indexdasbord from "../../../composant/navbar/indexDashbord";
import { BackLoadingSimple } from "../../../composant/loading/backLoading";
export default function PageCategoryHashtag() {
  return <Indexdasbord Children={<CategoryManagement />} />;
}

function CategoryManagement() {
  const [categories, setCategories] = useState([]);
  const [openForm, setOpenForm] = useState(false);
  const [formData, setFormData] = useState({
    id: null,
    name: "",
    photo: "",
  });
  const [photoPreview, setPhotoPreview] = useState("");
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [total, setTotal] = useState(0);
  const [errors, setErrors] = useState({});
  const { showAlert } = useAlertContext();

  const fetchCategories = useCallback(async () => {
    setLoading(true);
    try {
      const res = await Api_Token.get(
        `CategoryHasTagsRoute/GetAllCatgoryByEvent?page=${
          page + 1
        }&limit=${rowsPerPage}`
      );
      setCategories(res.data.data || []);
      setTotal(res.data.total || 0);
    } catch {
      showAlert("Erreur chargement catégories", "error");
    } finally {
      setLoading(false);
    }
  }, [page, rowsPerPage ,showAlert]);

  useEffect(() => {
    fetchCategories();
  }, [fetchCategories]);
  const handleEdit = (cat) => {
    setFormData({
      id: cat.id,
      name: cat.name || "",
      photo: cat.photo || "",
    });
    setPhotoPreview(cat.photo || "");
    setOpenForm(true);
  };

  const handleDelete = async (id) => {
    try {
      await Api_Token.delete(`CategoryHasTagsRoute/delete/${id}`);
      showAlert("Catégorie supprimée", "success");
      fetchCategories();
    } catch {
      showAlert("Erreur suppression", "error");
    }
  };

  const handlePhotoChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFormData({ ...formData, photo: file });
      setPhotoPreview(URL.createObjectURL(file));
    }
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    const newErrors = {};
    if (!formData.name || formData.name.trim() === "") {
      newErrors.name = "Le nom est requis";
    }
    if (!formData.id && !(formData.photo instanceof File)) {
      newErrors.photo = "La photo est requise";
    }
    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) {
      setLoading(false);
      return;
    }
    setLoading(true);
    try {
      let submitData = { ...formData };
      if (formData.photo instanceof File) {
        const form = new FormData();
        form.append("name", formData.name);
        form.append("categoryImage", formData.photo);
        if (formData.id) {
          await Api_Token.put(
            `CategoryHasTagsRoute/update/${formData.id}`,
            form,
            {
              headers: { "Content-Type": "multipart/form-data" },
            }
          );
          showAlert("Catégorie modifiée", "success");
        } else {
          await Api_Token.post("CategoryHasTagsRoute/create", form, {
            headers: { "Content-Type": "multipart/form-data" },
          });
          showAlert("Catégorie ajoutée", "success");
        }
      } else {
        if (formData.id) {
          await Api_Token.put(
            `CategoryHasTagsRoute/update/${formData.id}`,
            submitData
          );
          showAlert("Catégorie modifiée", "success");
        } else {
          await Api_Token.post("CategoryHasTagsRoute/create", submitData);
          showAlert("Catégorie ajoutée", "success");
        }
      }
      setOpenForm(false);
      setFormData({ id: null, name: "", photo: "" });
      setPhotoPreview("");
      fetchCategories();
    } catch {
      showAlert("Erreur formulaire", "error");
    }
    setLoading(false);
  };

  return (
    <Box p={4}>
      <Typography variant="h5" mb={3}>
        Gestion des catégories
      </Typography>
      <Button
        variant="contained"
        startIcon={<AddIcon />}
        onClick={() => {
          setFormData({ id: null, name: "", photo: "" });
          setPhotoPreview("");
          setOpenForm(true);
        }}
        sx={{ mb: 2 }}
      >
        Ajouter catégorie
      </Button>
      <Paper>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Nom</TableCell>
              <TableCell>Photo</TableCell>
              <TableCell>Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {categories.map((cat) => (
              <TableRow key={cat.id}>
                <TableCell>{cat.name}</TableCell>
                <TableCell>
                  {cat.urlImage ? (
                    <img
                      src={`${api_base}static/${cat.urlImage}`}
                      alt={cat.name}
                      style={{ width: 60, height: 60, objectFit: "cover" }}
                    />
                  ) : (
                    ""
                  )}
                </TableCell>
                <TableCell>
                  <IconButton color="primary" onClick={() => handleEdit(cat)}>
                    <EditIcon />
                  </IconButton>
                  <IconButton
                    color="error"
                    onClick={() => handleDelete(cat.id)}
                  >
                    <DeleteIcon />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
        <TablePagination
          component="div"
          count={total}
          page={page}
          onPageChange={(event, newPage) => setPage(newPage)}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={(event) => {
            setRowsPerPage(parseInt(event.target.value, 10));
            setPage(0);
          }}
          rowsPerPageOptions={[5, 10, 20]}
        />
      </Paper>
      <Dialog open={openForm} onClose={() => setOpenForm(false)}>
        <form onSubmit={handleFormSubmit}>
          <DialogTitle>
            {formData.id ? "Modifier" : "Ajouter"} catégorie
          </DialogTitle>
          <DialogContent>
            <TextField
              margin="dense"
              label="Nom"
              fullWidth
              required
              value={formData.name}
              onChange={(e) =>
                setFormData({ ...formData, name: e.target.value })
              }
              error={!!errors.name}
              helperText={errors.name}
            />
            <Box display="flex" alignItems="center" gap={2} mt={2}>
              <Button variant="outlined" component="label">
                Photo
                <input
                  type="file"
                  accept="image/*"
                  hidden
                  onChange={handlePhotoChange}
                />
              </Button>
              {errors.photo && (
                <Typography color="error" variant="caption">
                  {errors.photo}
                </Typography>
              )}
              {photoPreview && (
                <Box display="flex" alignItems="center" gap={1}>
                  <img
                    src={photoPreview}
                    alt="preview"
                    style={{ width: 80, height: 80, objectFit: "cover" }}
                  />
                  <Button
                    color="error"
                    size="small"
                    onClick={() => {
                      setFormData({ ...formData, photo: "" });
                      setPhotoPreview("");
                    }}
                  >
                    Supprimer
                  </Button>
                </Box>
              )}
            </Box>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setOpenForm(false)}>Annuler</Button>
            <Button type="submit" color="primary">
              {formData.id ? "Modifier" : "Ajouter"}
            </Button>
          </DialogActions>
        </form>
      </Dialog>
      <BackLoadingSimple open={loading} />
    </Box>
  );
}
